export default "__VITE_ASSET__2584ab32__"